export default {
  units: "feet",
  radius: 20902259.664
};